<template>
    	         	<div class="fluid w-100 accordion_panel program_guide_course_structure">
                  <template>
                    <div class="row accordion">
                      <div class="col-12 accordion_crd">
                        <b-card-header header-tag="header" class="row sec_hd head" role="tab" block v-b-toggle="'courses'+parentCategory.uuid" variant="info">
                          <div class="col-1 ic_container">
                            <div class="ic ic-expand_r"></div>
                            <div class="ic ic-collapse_r"></div>
                          </div>
                          <div class="col-7 pr-0 ml-0 hd_txt" style="max-width: 232px;">
                            <div v-html="getParentLabel(parentCategory.title)"></div>
                          </div>
                          <template v-if="courseStructure.length === 0 && parentCategory.total===1">
                          <div class="col-4 pr-0 txt_container completed" v-if=" parentCategory.total === parentCategory.completed" style="margin-top: 1px; margin-left: auto;">
                                <div class="ic_container">
                                  <span class="ic ic27-complete"></span>
                                </div>
                                <div class="status_info">
                                  <span>Completed</span>
                                </div>
                          </div>
                          <div class="col-4 pr-0 txt_container pending" v-else style="margin-top: 1px; margin-left: auto; max-width: 121px;">
                                <div class="ic_container ml-0" style="margin-right: 6px;">
                                  <span class="ic ic24-hour-glass"></span>
                                </div>
                                <div class="status_info">
                                  <span>Pending</span>
                                </div>
                          </div>
                          </template>
                        </b-card-header>

                        <div class="row">
                          <div class="col-12">
                            <b-collapse :id="'courses'+parentCategory.uuid"  visible role="tabpanel" class="row course_list_container">
                            <template v-if="!programGuide.showCategoryProgress" >
                            <div class="col-12 progress_bar progress_bar_v4" v-if="((courseStructure.length > 0 || (parentCategory.title.indexOf('Exam') !=-1 && parentCategory.total>1)) && !hideCategoryProgress)">
                              <div class="progress_bar_inner">
                                <program-category-score-and-progress-bar :hideScoreForStudent="programGuide.hideScoreForStudent" :performance="parentCategory.performance" :completeCount="parentCategory.completed"
                                  :totalCount="parentCategory.total" :inProgressCount="parentCategory.inProgress">
                                </program-category-score-and-progress-bar>
                              </div>
                            </div>
                            </template>

                              <div class="col-12 course_row" v-for="(course, index) in courseStructure" :key="course.originUuid" :class="course.waiveStatus ? 'waived_course_row' : ''">
                              <template v-if="course.entityType !== 'folder'">
                                <div class="row">
                                  <div class="col-3">
                                    <div class="thumbnail_sec">
                                      <div class="thumbnail" :style="{background: setThumbnailBgColor(course.originUuid)}">
																				<div v-html="setThumbnailTitle(course)"></div>
                                      </div>
																			<template v-if="(course.entityType === 'catalog')">
																				<div class="credit_info">
																					{{course.creditsEarned}} credits
																				</div>
																			</template>
                                      <template v-if="course.entityType === 'deliverycontext' && transactionValidity.transactionValid">
                                        <div class="lnk_container" style="margin-left: auto;">
                                          <b-link class="" v-b-modal="'waiveModal_' + parentCategory.uuid + index" style="float: left; margin-top: 0px; margin-left: 11px;" v-if="course.waiveStatus">
                                            <span class="">Waived</span>
                                          </b-link>
                                        </div>
                                        </template>
                                    </div>
                                  </div>
																	<div class="col-9 col_title">
                                    <div class="title_txt" v-if="course.entityType === 'deliverycontext' && transactionValidity.transactionValid && course.releaseStatus" :class="((course.entityType === 'deliverycontext') ? 'active_link' : '')" @click="navigateToCourseDashboard(course)">{{course.title}} </div>

                                    <div class="title_txt" v-if="course.entityType === 'deliverycontext' && transactionValidity.transactionValid && !course.releaseStatus">{{course.title}}</div>
                                    <div class="title_txt" v-if="course.entityType === 'catalog' ">{{course.title}}</div>

                                    <template v-if="course.entityType === 'deliverycontext' && transactionValidity.transactionValid">
                                      <div class="lnk_container" style="margin-left: auto;">
                                        <b-link class="btn_lock_unlock" v-b-modal="'releaseModal_' + parentCategory.uuid + index" v-if="!course.waiveStatus && !course.releaseStatus">
                    											<span class="ic22-lock"></span>
                    										</b-link>
                                        <!--
                                        <b-link class="btn_waive" v-b-modal="'waiveModal_' + parentCategory.uuid + index" style="float: right; margin-top: 0px; margin-right: 1px;" v-if="course.waiveStatus">
                                        <span class="course_w">w</span>
                                        </b-link>
                                        -->
                                      </div>
                                      <div class="modal_popup_container custom_modal_v4 course_unlock_modal">
                                        <b-modal class="description_modal" title="Course is Locked" :id="'releaseModal_' + parentCategory.uuid + index" ok-only ok-title="ok">
                                          <div class="ic_container">
                                            <span class="ic ic22-lock"></span>
                                          </div>
                                          <div class="row">
                                            <div class="col-12 txt_row">
                                              <div v-html="course.title"></div>
                                            </div>
                                            <div class="col-12 txt_row">
                                              <div v-html="course.releaseLogicDetail"></div>
                                            </div>
                                          </div>
                                        </b-modal>
                                      </div>
                                      <div class="modal_popup_container custom_modal_v4 course_unlock_modal">
                                        <b-modal title="Course Waived" class="description_modal" :id="'waiveModal_' + parentCategory.uuid + index" ok-only ok-title="ok">

                                          <div class="ic_container">
                                            <span class="btn_waive">
                                              <span class="course_w">W</span>
                                            </span>
                                          </div>

                                          <div class="row txt_row mt-2">
                                            <div class="col-3 fld_label">
                                              Course
                                            </div>
                                            <div class="col-9 fld_val">
                                              {{course.title}}
                                            </div>
                                          </div>

                                          <div class="row txt_row mt-4">
                                            <div class="col-3 fld_label">
                                              Reason
                                            </div>
                                            <div class="col-9 fld_val">
                                              <div v-html="course.waiveLogicDetail"></div>
                                            </div>
                                          </div>

                                        </b-modal>
                                      </div>

                                    </template>

																	</div>
                                </div> <!-- -->

                                <div class="row">
																	<div class="col-12 title">

																		<div class="row">
		                                  <template v-if="(course.entityType === 'deliverycontext')">
		                                    <div class="col-12 progress_bar" v-if="(transactionValidity.transactionValid && (course.releaseStatus || course.waiveStatus))">
		                                      <program-course-score-and-progress-bar  :hideScoreForStudent="programGuide.hideScoreForStudent":course-id="course.originUuid":waiveStatus="course.waiveStatus" @progressSummary="aggregateProgressSummary"></program-course-score-and-progress-bar>
		                                    </div>
		                                  </template>
		                        </div>

                                      <div class="description_sec">
                                        <div :id="'entityDesc_' + index" class="description" v-if="course.description">
    																			<span class="desc_txt ace_sec_txt" v-html="course.description">
    	                                    </span>
    																		</div>

    																		<template v-if="showMoreDescLink(course.description)">
    																			<div class="lnk_container">
                                          	<b-link :class="showMoreDescLnk(index)" v-b-modal="'entityDescModal_' + parentCategory.uuid + index">more</b-link>
    																			</div>
    																			<b-modal class="description_modal" size="xl" :id="'entityDescModal_' + parentCategory.uuid + index" :title="course.title" ok-only ok-title="close">
      																			<div class="row">
                                              <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12">
                                                <div v-html="course.description"></div>
                                              </div>
      																			</div>
    																			</b-modal>
                                        </template>
                                      </div>

                                  </div>
																</div>

                                <template v-if="course.entityType === 'catalog'">
                                  <template v-if="userSISProgramMapping.status === 'ACCEPTED' && (userSISProgramMapping.feeStatus === 'PAID' || userSISProgramMapping.feeStatus === 'WAIVED')">
                                    <div class="row enrollment_pending_info">
                                      <div class="col-1 ic_container">
                                        <span class="ic ic22-hour-glass"></span>
                                      </div>
                                      <div class="col-11 status_info">
                                        <span class="txt">Enrollment Pending</span>
                                      </div>
                                    </div>
                                  </template>
                                </template>

															</template>
		                          <template v-if="course.entityType === 'folder'">
		                              <program-guide-course-structure  :courseStructure="getCourses(course)" :parentCategory="course" firstCategory="false" :programGuide="programGuide" :transactionValidity="transactionValidity" > </program-guide-course-structure>
		                          </template>

                              </div>
                            </b-collapse>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-if="(courseStructure.length ===0 && firstCategory !=='false' )">
      							<b-jumbotron>
              				<h4 class="text-center ace_sec_txt">Progress is currently not available.</h4>
            				</b-jumbotron>
                  </template>
    			  		</div>
</template>

<script>
  import _ from 'lodash'
  import { mapState, mapActions } from 'vuex'
  import ProgramCourseScoreAndProgressBar from './ProgramCourseScoreAndProgressBar'
  import ProgramCategoryScoreAndProgressBar from './ProgramCategoryScoreAndProgressBar'

  export default {
    name: 'program-guide-course-structure',
    props: ['courseStructure', 'parentCategory', 'firstCategory', 'transactionValidity', 'programGuide'],
    components: {
      ProgramCourseScoreAndProgressBar,
      ProgramCategoryScoreAndProgressBar
    },
    data: () => {
      return {
        courses: [],
        programGuide: {},
        planningStream: {},
        DEFAULT_TYPE: 'MAJOR',
        DEFAULT_RETURN_TO: 'exploreIntro',
        EXPLORE_RESULTS: 'exploreProgramGuideResults',
        clickedCourse: '',
        selectedStatus: '',
        courseStatusMap: {
          0: 'Not Started',
          1: 'In Progress',
          2: 'Completed',
          7: 'Couldn\'t Complete'
        },
        courseStatusBackgroundMap: {
          0: 'status-not-started',
          1: 'status-in-progress',
          2: 'status-completed',
          7: 'status-not-completed'
        },
        score: 0,
        performance: 0,
        childrenCount: 0,
        childrenCompleteCount: 0,
        progressSummaries: [],
        isScoreNotAvailable: true,
        transactionValidity: {},
        userSISProgramMapping : {}
      }
    },
    mounted () {
//      this.loadDataForProgramGuideMyStatus()
    },
    methods: {
      ...mapActions([
        'loadProgramGuide',
        'loadStreamWithStructure',
        'updateProgramCourseStatus',
        'loadCheckTransactionValidity'
      ]),
      async loadDataForProgramGuideMyStatus () {
        let cipCode = this.cipCode
        let programGuideCode = this.programGuideCode
        this.programGuide = await this.loadProgramGuide({
          cipCode: cipCode,
          programGuideCode: programGuideCode,
          type: this.programGuideType,
          loadDataFromServer: true
        })
        if (!this.programGuide || !this.programGuide.cipCode) {
          return this.$router.push({ name: this.returnTo })
        }
        this.transactionValidity = await this.loadCheckTransactionValidity(programGuideCode)
      },
      navigateToSelectedProgram (data) {
        let routerParams = {
          cipCode: this.cipCode,
          programGuideCode: this.programGuideCode,
          type: this.type,
          showBackToResultButton: true
        }
        return this.$router.push({name: 'programGuideMenu', params: routerParams})
      },
      resetData () {
        this.score = 0
        this.performance = 0
        this.childrenCount = 0
        this.childrenCompleteCount = 0
        this.courses = []
        this.programGuide = {}
        this.planningStream = {}
        this.progressSummaries = [],
        this.isScoreNotAvailable = true
      },
      getCourses (course) {
            let childStructure = course.structure
            if (childStructure) {
              let structure = JSON.parse(childStructure)
              return _.sortBy(structure, 'order')
            }else{
              return []
            }
      },
      getParentLabel(title){
      	return title ==='Explore'?'Courses':title
      },
      async populateStreamStructure () {
        this.resetData()
        this.planningStream = await this.loadStreamWithStructure(this.programGuideCode)
        let structure = this.planningStream.structure
        if (structure) {
          let children = JSON.parse(structure)
          if (children.length > 0) {
            let childStructure = children[0].structure
            if (childStructure) {
              let structure = JSON.parse(childStructure)
              this.courses = _.sortBy(structure, 'order')
            }
          }
        }
      },
      returnToClicked () {
        return this.$router.push({ name: this.returnTo })
      },
      deCamelCase () {
        if (!this.returnTo) {
          this.returnTo = this.DEFAULT_RETURN_TO
        }
        if (this.returnTo === this.EXPLORE_RESULTS) {
          return 'return to program results'
        }
        let result = this.returnTo.replace(/([A-Z])/g, ' $1')
        return 'return to ' + result
      },
      setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      setThumbnailTitle (course) {
        if ((course.title.indexOf('-') !== -1) && (course.title.indexOf('-') < 7)) {
          let splitted = course.title.split('-')
          if (splitted.length > 0) {
            return splitted[0]
          }
        }
        return course.title.substring(0, 7)
      },
      async updateCourseStatus (streamId, status) {
        let data = {
          uuid: streamId,
          status: status
        }
        this.updateProgramCourseStatus(data).then(result => {
          this.populateStreamStructure()
        })
      },
      openStatusDropDown (course) {
        this.selectedStatus = course.courseStatus
        if (this.clickedCourse) {
          this.closeStatusDropDown(false)
        } else {
          this.clickedCourse = course
          setTimeout(() => {
            this.$refs.courseStatusPopover.$emit('open')
          }, 250)
        }
      },
      closeStatusDropDown (toBeUpdated, status) {
        if (toBeUpdated) {
          this.updateCourseStatus(this.clickedCourse.uuid, status)
        }
        this.clickedCourse = ''
        this.selectedStatus = ''
        this.$refs.courseStatusPopover.$emit('close')
      },
      navigateToCourseDashboard (course) {
        if (course.entityType === 'deliverycontext') {
          this.$store.commit('LOAD_COURSE', {})
          this.$store.commit('LOAD_CLASS_SUMMARY', {})
          this.$store.commit('LOAD_COURSE_TOPICS', {})
          this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
          let courseId = course.originUuid
          return this.$router.push({name: 'courseDashboard', params: {uuid: courseId}})
        }
      },
      aggregateProgressSummary (progressSummary) {
        if ((progressSummary.status === 1) || (progressSummary.status === 2)) {
          this.isScoreNotAvailable = false
          this.progressSummaries.push(progressSummary)
          this.performance += progressSummary.performance
        }
        this.childrenCount += progressSummary.childrenCount
        this.childrenCompleteCount += progressSummary.childrenCompleteCount
        setTimeout(() => {
          this.score = (this.performance / this.progressSummaries.length).toFixed(1)
        }, 1000)
      },
      showMoreDescLnk (id) {
				let entityDescHeight = $('#entityDesc_' + id + ' desc_txt').height()
				if (entityDescHeight > 45) {
          return 'hide_more_link'
        } else {
          return 'show_more_link'
        }
      },
      showMoreDescLink (desc) {
        if(desc){
          desc = desc.replace( /(<([^>]+)>)/ig, '');
        }
        if (desc && desc.length > 101) {
          return true
        } else {
          return false
        }
      },
      showDesc (fullDesc){
        if(fullDesc){
          let desc = fullDesc.replace( /(<([^>]+)>)/ig, '');
          if(desc.length>101){
            return desc.substring(0,101) + '...'
          }
          return desc;
        }
        return fullDesc
      },
      statusClass (score, hideScore) {
        if (score && !this.isScoreNotAvailable && !hideScore) {
          if (score >= 90) {
            return 'gradeA'
          } else if (score >= 80 && score < 90) {
            return 'gradeB'
          } else if (score >= 65 && score < 80) {
            return 'gradeC'
          } else if (score >= 40 && score < 65) {
            return 'gradeD'
          } else if (score < 40) {
            return 'gradeE'
          }
        } else {
          return 'noGrade'
        }
      }
    },
    computed: {
      ...mapState({
        'packages': state => state.dashboard.packages
      }),
      programGuideType () {
        let programGuideType = this.type
        if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
          programGuideType = this.DEFAULT_TYPE
        }
        return programGuideType
      },
      returnToPage () {
        return this.returnTo || 'programGuideMenu'
      }
    }
  }
</script>

<style>
  div[id^="courseStatusPopup-"] .popover .arrow {
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideCourseStructure.vue